import { NavLink, NavLinkProps } from '@remix-run/react';
import clsx from 'clsx';
import { FC } from 'react';

export interface MenuSidebarLinkProps extends Pick<NavLinkProps, 'to'> {
  name: string;
}

export const MenuSidebarLink: FC<MenuSidebarLinkProps> = ({ to, name }) => {
  return (
    <li>
      <div className={clsx('flex h-12 w-full items-center')}>
        <NavLink
          to={to}
          className={({ isActive }) =>
            clsx(!isActive && 'hover:bg-palette-600/10', 'flex h-12 w-full items-center cursor-pointer')
          }
        >
          {({ isActive }) => (
            <div className={clsx('flex h-12 w-full items-center relative', isActive && 'bg-palette-400')}>
              <p
                className={clsx(
                  'flex h-12 w-full items-center pl-6 relative',
                  isActive ? 'dark:text-palette-1100 text-palette-1100' : 'dark:text-white'
                )}
              >
                {name}
              </p>
            </div>
          )}
        </NavLink>
      </div>
    </li>
  );
};
